import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import {
  contact,
  environment,
  locale,
  loggingBaseUrl,
  snowplow,
  tenant
} from './services/ConfigService'
import Chat from './plugins/chat/index'
import Snowplow from './plugins/snowplow'
import logger from './utilities/logger'
import './registerServiceWorker'

logger.setupLogging(
  environment,
  tenant,
  loggingBaseUrl,
  process.env.PACKAGE_VERSION
)

Vue.use(Snowplow, {
  cdnConfig: snowplow.cdnConfig,
  cdnConfigLegacy: snowplow.cdnConfigLegacy,
  environment,
  locale,
  tenant
})

Vue.use(Chat, contact)

window.addEventListener('error', ({ message, error }) => {
  logger.error(message, error)
})

window.addEventListener('unhandledrejection', ({ reason: { message, status, stack } }) => {
  logger.error(message, { status, stack })
})

Vue.config.productionTip = process.env.NODE_ENV !== 'production'
Vue.config.performance = process.env.NODE_ENV !== 'production'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#consumerHelpAppHook')
